import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=54989bc3&scoped=true&"
import script from "./GalleryView.vue?vue&type=script&lang=js&"
export * from "./GalleryView.vue?vue&type=script&lang=js&"
import style0 from "./GalleryView.vue?vue&type=style&index=0&id=54989bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54989bc3",
  null
  
)

export default component.exports